import { render, staticRenderFns } from "./addcoll.vue?vue&type=template&id=e8216126&scoped=true&"
import script from "./addcoll.vue?vue&type=script&lang=js&"
export * from "./addcoll.vue?vue&type=script&lang=js&"
import style0 from "../../assets/css/common/nav.less?vue&type=style&index=0&id=e8216126&scoped=true&lang=less&"
import style1 from "../../assets/css/common/form.less?vue&type=style&index=1&id=e8216126&scoped=true&lang=less&"
import style2 from "../../assets/css/common/details.less?vue&type=style&index=2&id=e8216126&scoped=true&lang=less&"
import style3 from "./addcoll.vue?vue&type=style&index=3&id=e8216126&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8216126",
  null
  
)

export default component.exports